// @generated by protoc-gen-es v1.10.0
// @generated from file penumbra/core/component/auction/v1/auction.proto (package penumbra.core.component.auction.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { Any, proto3 } from "@bufbuild/protobuf";
import { Position, PositionId } from "../../dex/v1/dex_pb.js";
import { AssetId, BalanceCommitment, Metadata, Value, ValueView } from "../../../asset/v1/asset_pb.js";
import { Amount } from "../../../num/v1/num_pb.js";

/**
 * The configuration parameters for the auction component.
 *
 * @generated from message penumbra.core.component.auction.v1.AuctionParameters
 */
export const AuctionParameters = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.auction.v1.AuctionParameters",
  [],
);

/**
 * Genesis data for the auction component.
 *
 * @generated from message penumbra.core.component.auction.v1.GenesisContent
 */
export const GenesisContent = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.auction.v1.GenesisContent",
  () => [
    { no: 1, name: "params", kind: "message", T: AuctionParameters },
  ],
);

/**
 * @generated from message penumbra.core.component.auction.v1.AuctionStateByIdRequest
 */
export const AuctionStateByIdRequest = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.auction.v1.AuctionStateByIdRequest",
  () => [
    { no: 1, name: "id", kind: "message", T: AuctionId },
  ],
);

/**
 * @generated from message penumbra.core.component.auction.v1.AuctionStateByIdResponse
 */
export const AuctionStateByIdResponse = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.auction.v1.AuctionStateByIdResponse",
  () => [
    { no: 2, name: "auction", kind: "message", T: Any },
    { no: 3, name: "positions", kind: "message", T: Position, repeated: true },
  ],
);

/**
 * @generated from message penumbra.core.component.auction.v1.AuctionStateByIdsRequest
 */
export const AuctionStateByIdsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.auction.v1.AuctionStateByIdsRequest",
  () => [
    { no: 1, name: "id", kind: "message", T: AuctionId, repeated: true },
  ],
);

/**
 * @generated from message penumbra.core.component.auction.v1.AuctionStateByIdsResponse
 */
export const AuctionStateByIdsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.auction.v1.AuctionStateByIdsResponse",
  () => [
    { no: 1, name: "id", kind: "message", T: AuctionId },
    { no: 2, name: "auction", kind: "message", T: DutchAuctionState },
    { no: 3, name: "positions", kind: "message", T: Position, repeated: true },
  ],
);

/**
 * A unique identifier for an auction, obtained from hashing a domain separator
 * along with the immutable part of an auction description.
 *
 * @generated from message penumbra.core.component.auction.v1.AuctionId
 */
export const AuctionId = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.auction.v1.AuctionId",
  () => [
    { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * A bearer NFT tracking ownership of an auction and its proceeds.
 *
 * @generated from message penumbra.core.component.auction.v1.AuctionNft
 */
export const AuctionNft = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.auction.v1.AuctionNft",
  () => [
    { no: 1, name: "id", kind: "message", T: AuctionId },
    { no: 2, name: "seq", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * Describes a Dutch auction using programmatic liquidity on the DEX.
 *
 * @generated from message penumbra.core.component.auction.v1.DutchAuctionDescription
 */
export const DutchAuctionDescription = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.auction.v1.DutchAuctionDescription",
  () => [
    { no: 1, name: "input", kind: "message", T: Value },
    { no: 2, name: "output_id", kind: "message", T: AssetId },
    { no: 3, name: "max_output", kind: "message", T: Amount },
    { no: 4, name: "min_output", kind: "message", T: Amount },
    { no: 5, name: "start_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 6, name: "end_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 7, name: "step_count", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 8, name: "nonce", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * @generated from message penumbra.core.component.auction.v1.DutchAuctionState
 */
export const DutchAuctionState = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.auction.v1.DutchAuctionState",
  () => [
    { no: 1, name: "seq", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "current_position", kind: "message", T: PositionId },
    { no: 3, name: "next_trigger", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 4, name: "input_reserves", kind: "message", T: Amount },
    { no: 5, name: "output_reserves", kind: "message", T: Amount },
  ],
);

/**
 * @generated from message penumbra.core.component.auction.v1.DutchAuction
 */
export const DutchAuction = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.auction.v1.DutchAuction",
  () => [
    { no: 1, name: "description", kind: "message", T: DutchAuctionDescription },
    { no: 2, name: "state", kind: "message", T: DutchAuctionState },
  ],
);

/**
 * Initiates a Dutch auction using protocol-controlled liquidity.
 *
 * @generated from message penumbra.core.component.auction.v1.ActionDutchAuctionSchedule
 */
export const ActionDutchAuctionSchedule = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.auction.v1.ActionDutchAuctionSchedule",
  () => [
    { no: 1, name: "description", kind: "message", T: DutchAuctionDescription },
  ],
);

/**
 * Terminate the auction associated with the specified `auction_id`
 *
 * @generated from message penumbra.core.component.auction.v1.ActionDutchAuctionEnd
 */
export const ActionDutchAuctionEnd = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.auction.v1.ActionDutchAuctionEnd",
  () => [
    { no: 1, name: "auction_id", kind: "message", T: AuctionId },
  ],
);

/**
 * Withdraw funds from the ended auction associated with the specified `auction_id`
 *
 * @generated from message penumbra.core.component.auction.v1.ActionDutchAuctionWithdraw
 */
export const ActionDutchAuctionWithdraw = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.auction.v1.ActionDutchAuctionWithdraw",
  () => [
    { no: 1, name: "auction_id", kind: "message", T: AuctionId },
    { no: 2, name: "seq", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "reserves_commitment", kind: "message", T: BalanceCommitment },
  ],
);

/**
 * A plan to a `ActionDutchAuctionWithdraw` which contains both private and public data.
 *
 * @generated from message penumbra.core.component.auction.v1.ActionDutchAuctionWithdrawPlan
 */
export const ActionDutchAuctionWithdrawPlan = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.auction.v1.ActionDutchAuctionWithdrawPlan",
  () => [
    { no: 1, name: "auction_id", kind: "message", T: AuctionId },
    { no: 2, name: "seq", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "reserves_input", kind: "message", T: Value },
    { no: 4, name: "reserves_output", kind: "message", T: Value },
  ],
);

/**
 * An `ActionDutchAuctionSchedule` augmented with additional metadata.
 *
 * @generated from message penumbra.core.component.auction.v1.ActionDutchAuctionScheduleView
 */
export const ActionDutchAuctionScheduleView = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.auction.v1.ActionDutchAuctionScheduleView",
  () => [
    { no: 1, name: "action", kind: "message", T: ActionDutchAuctionSchedule },
    { no: 2, name: "auction_id", kind: "message", T: AuctionId },
    { no: 3, name: "input_metadata", kind: "message", T: Metadata },
    { no: 4, name: "output_metadata", kind: "message", T: Metadata },
  ],
);

/**
 * An `ActionDutchAuctionWithdraw` augmented with additional metadata.
 *
 * @generated from message penumbra.core.component.auction.v1.ActionDutchAuctionWithdrawView
 */
export const ActionDutchAuctionWithdrawView = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.auction.v1.ActionDutchAuctionWithdrawView",
  () => [
    { no: 1, name: "action", kind: "message", T: ActionDutchAuctionWithdraw },
    { no: 2, name: "reserves", kind: "message", T: ValueView, repeated: true },
  ],
);

/**
 * @generated from message penumbra.core.component.auction.v1.EventDutchAuctionScheduled
 */
export const EventDutchAuctionScheduled = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.auction.v1.EventDutchAuctionScheduled",
  () => [
    { no: 1, name: "auction_id", kind: "message", T: AuctionId },
    { no: 2, name: "description", kind: "message", T: DutchAuctionDescription },
  ],
);

/**
 * @generated from message penumbra.core.component.auction.v1.EventDutchAuctionUpdated
 */
export const EventDutchAuctionUpdated = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.auction.v1.EventDutchAuctionUpdated",
  () => [
    { no: 1, name: "auction_id", kind: "message", T: AuctionId },
    { no: 2, name: "state", kind: "message", T: DutchAuctionState },
  ],
);

/**
 * @generated from message penumbra.core.component.auction.v1.EventDutchAuctionEnded
 */
export const EventDutchAuctionEnded = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.auction.v1.EventDutchAuctionEnded",
  () => [
    { no: 1, name: "auction_id", kind: "message", T: AuctionId },
    { no: 2, name: "state", kind: "message", T: DutchAuctionState },
    { no: 3, name: "reason", kind: "enum", T: proto3.getEnumType(EventDutchAuctionEnded_Reason) },
  ],
);

/**
 * The reason the auction ended.
 *
 * @generated from enum penumbra.core.component.auction.v1.EventDutchAuctionEnded.Reason
 */
export const EventDutchAuctionEnded_Reason = /*@__PURE__*/ proto3.makeEnum(
  "penumbra.core.component.auction.v1.EventDutchAuctionEnded.Reason",
  [
    {no: 0, name: "REASON_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "REASON_EXPIRED", localName: "EXPIRED"},
    {no: 2, name: "REASON_FILLED", localName: "FILLED"},
    {no: 3, name: "REASON_CLOSED_BY_OWNER", localName: "CLOSED_BY_OWNER"},
  ],
);

/**
 * @generated from message penumbra.core.component.auction.v1.EventDutchAuctionWithdrawn
 */
export const EventDutchAuctionWithdrawn = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.auction.v1.EventDutchAuctionWithdrawn",
  () => [
    { no: 1, name: "auction_id", kind: "message", T: AuctionId },
    { no: 2, name: "state", kind: "message", T: DutchAuctionState },
  ],
);

/**
 * A message emitted when value flows *into* the auction component.
 *
 * @generated from message penumbra.core.component.auction.v1.EventValueCircuitBreakerCredit
 */
export const EventValueCircuitBreakerCredit = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.auction.v1.EventValueCircuitBreakerCredit",
  () => [
    { no: 1, name: "asset_id", kind: "message", T: AssetId },
    { no: 2, name: "previous_balance", kind: "message", T: Amount },
    { no: 3, name: "new_balance", kind: "message", T: Amount },
  ],
);

/**
 * A message emitted when value flows *out* of the auction component.
 *
 * @generated from message penumbra.core.component.auction.v1.EventValueCircuitBreakerDebit
 */
export const EventValueCircuitBreakerDebit = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.auction.v1.EventValueCircuitBreakerDebit",
  () => [
    { no: 1, name: "asset_id", kind: "message", T: AssetId },
    { no: 2, name: "previous_balance", kind: "message", T: Amount },
    { no: 3, name: "new_balance", kind: "message", T: Amount },
  ],
);

